import React, { useRef } from 'react'
import Avatar from './Avatar'
import Gap from './Gap'

export interface UserListItemProps {
  id: string
  nickname: string
  username: string
  profileImage?: string
  actionButtons?: React.ReactNode
  /** 클릭 시 해당 사용자 프로필로 이동 등 콜백 */
  onClick?: () => void
  /** 길게 누르면 실행(예: 내 팔로워 삭제). 있으면 롱프레스 활성화. */
  onLongPress?: () => void
}

const LONG_PRESS_MS = 600

const UserListItem: React.FC<UserListItemProps> = ({
  id,
  nickname,
  username,
  profileImage,
  actionButtons,
  onClick,
  onLongPress,
}) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const firedRef = useRef(false)

  const startPress = () => {
    if (!onLongPress) return
    firedRef.current = false
    timerRef.current = setTimeout(() => {
      firedRef.current = true
      onLongPress()
    }, LONG_PRESS_MS)
  }
  const cancelPress = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }
  const handleClick = () => {
    // 롱프레스가 발동된 직후의 click은 이동을 막는다.
    if (firedRef.current) {
      firedRef.current = false
      return
    }
    onClick?.()
  }
  const userInfoContent = (
    <>
      {/* 프로필 이미지 */}
      <Avatar nickname={nickname} profileImage={profileImage} size={47} />

      {/* 사용자 정보 */}
      <div className="flex-1 min-w-0 flex flex-col">
        <span className="font-pretendard font-bold text-16px leading-125% text-brown-80%-main text-ellipsis-1">
          {username}
        </span>
        <Gap height={4} />
        <span className="font-pretendard font-regular text-16px leading-125% text-brown-80%-main text-ellipsis-1">
          {nickname}
        </span>
      </div>
    </>
  )

  return (
    <div
      className={`
        w-full
        flex
        items-center
        gap-16px
        py-12px
      `}
    >
      {onClick || onLongPress ? (
        <button
          type="button"
          onClick={handleClick}
          onPointerDown={startPress}
          onPointerUp={cancelPress}
          onPointerLeave={cancelPress}
          onPointerCancel={cancelPress}
          onContextMenu={onLongPress ? (e) => e.preventDefault() : undefined}
          style={onLongPress ? { touchAction: 'pan-y' } : undefined}
          className={`flex flex-1 min-w-0 items-center gap-16px text-left ${
            onLongPress ? 'select-none' : ''
          }`}
        >
          {userInfoContent}
        </button>
      ) : (
        userInfoContent
      )}

      {/* 팔로우 버튼 */}
      {actionButtons && actionButtons}
    </div>
  )
}

export default UserListItem
